{
    "name": "AppComponentVersions",
    "schemas": "@wix/dm-fragment-schemas/appComponentVersions",
    "defaultConfigurations": {
        "singletonInstance": "AppComponentVersionsSingleton"
    }
}
